module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT sgc-1"
  }, [_vm._v("\n    come sweetly\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    It starts"), _c('br'), _vm._v("\n    The way\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    It ends—"), _c('br'), _vm._v("\n    Fingers of\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Impossible light"), _c('br'), _vm._v("\n    Crawling\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Over your"), _c('br'), _vm._v("\n    Face. In\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Between—mind-"), _c('br'), _vm._v("\n    Less waiting.\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Mouth gunk"), _c('br'), _vm._v("\n    Or a gunked\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Up heart—"), _c('br'), _vm._v("\n    Going is just\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("\n    Climbing"), _c('br'), _vm._v("\n    Back inside.\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4df96a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/alex_9781571318060_oeb_fm2_r1.vue
// module id = 69
// module chunks = 0